import { render } from 'preact';
import './index.css';
import { App } from './App.tsx';

const root = document.getElementById('app');
if (!root) throw new Error('#app element missing from index.html');
render(<App />, root);
